import { MetaDescription } from 'src/components/seo/MetaDescription';
import { MetaTitle } from 'src/components/seo/MetaTitle';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { ProductDTO } from 'src/models/pim';

export const ProductPageSEO = (_product: ProductDTO) => {
  const product = useTranslateItem(_product);

  return (
    <>
      <MetaTitle>
        {[product.name, product.tagline].filter(Boolean).join(' - ')}
      </MetaTitle>
      <MetaDescription>{product.description_short}</MetaDescription>
    </>
  );
};
